import { Reveal } from '@/components/motion';
import { FAQ } from '@/data/site';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Link } from 'react-router-dom';

export default function FAQPage() {
  return (
    <>
      <section className="pt-16 md:pt-24 pb-14" data-testid="faq-hero">
        <div className="container-x max-w-4xl">
          <Reveal>
            <div className="overline mb-6">FAQ</div>
            <h1 className="h-display text-balance">Everything most people ask us — answered.</h1>
            <p className="body-lg mt-8 max-w-2xl text-pretty">
              Still not sure? Chat with our AI assistant (bottom right) or send us a message — we respond to every
              enquiry within one business day.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24" data-testid="faq-list">
        <div className="container-x max-w-3xl">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQ.map((f, i) => (
              <Reveal key={f.q} delay={i * 0.03}>
                <AccordionItem
                  value={`faq-${i}`}
                  className="border border-neutral-200 rounded-2xl px-6 bg-neutral-50 data-[state=open]:bg-white data-[state=open]:border-brand transition-colors"
                >
                  <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left font-display font-bold text-lg text-ink hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent data-testid={`faq-a-${i}`} className="text-ink-soft body-md pb-6 pt-2">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              </Reveal>
            ))}
          </Accordion>
          <div className="mt-14 text-center">
            <p className="body-md">Didn't find your answer?</p>
            <Link to="/contact" className="btn-primary mt-4">Contact us</Link>
          </div>
        </div>
      </section>
    </>
  );
}
